<template>
    <div class="flex flex-col gap-8 cursor-move p-2">
        <div
            v-for="(item, index) in routingList"
            :key="index"
            class="flex flex-row gap-10"
            draggable="true"
            @dragover="handleDragOver($event, item, index)"
            @dragend="handleDragEnd($event, item, index)"
            @mouseover="handleMouseOver(index, index)"
            @mouseleave="handleMouseLeave(index)">
            <select-node
                :required="false"
                :no-label="true"
                :text-change="routingList[index] ? routingList[index].name : ''"
                :text-default="item.name || ''"
                :size="90"
                :disabled="disabled"
                @change-input="(nodeData:any, nodeDetail: any)=>handleChangeInput(nodeData, index, nodeDetail)" />
            <div class="flex flex-col items-center">
                <hts-tooltip>
                    <span class="font-bold">
                        {{ $t('labels.dragToChange') }}
                    </span>
                    <template #reference>
                        <hi-map-pin-icon
                            v-if="index === routingList.length - 1"
                            class="h-5 w-5 fill-orange-700 mt-2 mr-1" />
                        <div
                            v-else
                            class="w-4 h-4 border-2 border-gray-900 rounded-full bg-white mt-3" />
                    </template>
                </hts-tooltip>
                <div v-if="index !== routingList.length - 1">
                    <img
                        v-if="index !== routingList.length - 1"
                        class="pt-5"
                        src="/assets/dash-line.png" >
                </div>
            </div>
            <div
                class="mt-2 cursor-pointer"
                @click="handleDelete(index)">
                <hts-tooltip>
                    <span class="font-bold">
                        {{ $t('labels.routingModule.deleteNode') }}
                    </span>
                    <template #reference>
                        <hi-x-circle-icon
                            :class="[checkHoverList[index] ? 'fill-error-500' : 'fill-white']"
                            class="h-5 w-5"
                            aria-hidden="true" />
                    </template>
                </hts-tooltip>
            </div>
        </div>
        <div
            v-if="!disabled"
            class="flex flex-row gap-3 cursor-pointer"
            @click="handleAddNodeInput">
            <div class="h-7 w-7 mt-3 border-2 border-orange-500 rounded-full flex items-center justify-center">
                <hi-plus-icon class="h-5 w-5 fill-orange-700" />
            </div>
            <span class="font-bold mt-3">
                {{ $t('labels.addDestination') }}
            </span>
        </div>
    </div>
</template>
<script setup lang="ts">
import SelectNode from '@/pages/admincp/node/ignore/autocomplete/select-node.vue'

const props = defineProps({
  routingInfo: {
    type: Array<{ [key: string]: any }>,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
const routingInit = reactive<Array<{ [key: string]: any }>>([
  {
    id: '',
    name: '',
    lat: 0,
    lng: 0
  },
  {
    id: '',
    name: '',
    lat: 0,
    lng: 0
  }
])
const checkHoverList = reactive<Array<any>>([false, false])
const routingList = computed(() => {
  if (props.routingInfo.length) {
    return props.routingInfo
  }
  return routingInit
})
const emits = defineEmits(['click', 'change'])
const indexStart = ref()
const indexEnd = ref()
const handleChangeInput = (nodeData: any, index: any, nodeDetail: any) => {
  const checkExist = routingList.value.find((item: any) => item.name === nodeData.name)
  if (checkExist) {
    return $toast().error($t('validations.nodeIsExist'))
  }
  routingList.value[index].id = nodeData._id
  routingList.value[index].name = nodeData.name
  routingList.value[index].lat = parseFloat(nodeDetail.lat)
  routingList.value[index].lng = parseFloat(nodeDetail.lng)
  emits('change', routingList.value)
}
const handleDragOver = (event: any, item: any, index: any) => {
  if (props.disabled) {
    return true
  }
  event.preventDefault()
  indexEnd.value = index
}
const handleDragEnd = (event: any, item: any, index: any) => {
  if (props.disabled) {
    return true
  }
  event.preventDefault()
  indexStart.value = index
  const itemEnd = routingList.value[indexEnd.value]
  routingList.value[indexEnd.value] = routingList.value[indexStart.value]
  routingList.value[indexStart.value] = itemEnd
  emits('change', routingList.value)
}
const handleAddNodeInput = () => {
  routingList.value.push({
    name: '',
    id: ''
  })
  checkHoverList.push(false)
}
const handleDelete = (index: any) => {
  if (index < 0) {
    return true
  }
  routingList.value.splice(index, 1)
  checkHoverList.splice(index, 1)
}
const handleMouseOver = (index: any, position: any) => {
  if (index < 0) {
    return true
  }
  if (routingList.value.length === 2) {
    return true
  }
  checkHoverList[index] = true
}
const handleMouseLeave = (index: any) => {
  if (index < 0) {
    return true
  }
  if (routingList.value.length === 2) {
    return true
  }
  checkHoverList[index] = false
}
</script>
